interface _solicitudArrendamiento {
    id: number;
    solicitud_id: number;
    docSolicitud: any;
    contribuyente_id: number;
    establecimiento_id: number;
    giro_id: number;
    alta_sat_id: number;
    docSat: any;
    estatus_solicitud_id:number;
    contrato_arrendamiento_id: number;
    docContrato_arrendamiento: any;
    fecha_inicio: any;
    fecha_fin: any;
    renta_mes: number;
    porcen_ayunta: number;
    estatus_contrato_id: number;
    id_recibo_pago: number;
}

class solicitudArrendamiento implements _solicitudArrendamiento {
    id=0;
    solicitud_id=0;
    docSolicitud=null;
    contribuyente_id=0;
    establecimiento_id=0;
    giro_id=0;
    alta_sat_id=0;
    docSat= null;
    estatus_solicitud_id=0;
    contrato_arrendamiento_id=0;
    docContrato_arrendamiento=null;
    fecha_inicio: any = "";
    fecha_fin: any = "";
    renta_mes= 0;
    porcen_ayunta= 0;
    estatus_contrato_id=0;
    id_recibo_pago=0;
    
}

export { solicitudArrendamiento, _solicitudArrendamiento }